import cake2 from '../img/menu/cake2.jpg';
import cake17 from '../img/menu/cake17.jpg';
import cake21 from '../img/menu/cake21.jpg';
import cake23 from '../img/menu/cake23.jpeg';
import cake24 from '../img/menu/cake24.jpg';
import cake25 from '../img/menu/cake25.jpg';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Menu = ({ setSelectedImg }) => {
  return (
    <section id="menu" className="text-gray-600 body-font">
      <div className="container px-5 py-24 mx-auto">
        <div className="text-center mb-20">
          <h1
            className="
            text-5xl
            font-medium
            title-font
            mb-4
          "
          >
            Menu of the Week
          </h1>
          <div className="flex mt-6 justify-center">
            <div
              className="
              w-28
              h-2
              rounded-full
            bg-purple-500
              inline-flex
            "
            ></div>
          </div>
        </div>
        <div className="flex flex-wrap -m-4">
          <div className="p-4 md:w-1/3">
            <div
              className="
              h-full
              border-2 border-gray-200 border-opacity-60
              rounded-lg
              overflow-hidden
            "
            >
              <motion.div className="menu-img" whileHover={{ opacity: 1 }}>
                <img
                  className="
                    lg:h-48
                    md:h-36
                    w-full
                    object-cover object-center
                    cursor-pointer
                  "
                  src={cake17}
                  alt="cake17"
                  onClick={() => setSelectedImg(cake17)}
                />
              </motion.div>
              <div className="p-6">
                <h1
                  className="
                title-font
                text-2xl
                font-medium
              text-gray-600
                mb-1
              "
                >
                  Chocolaty Bliss Cake
                </h1>
                <p className="leading-relaxed mb-1">Price: ৳800 per pound</p>
                <div className="flex items-center flex-wrap">
                  <a
                    rel="noreferrer"
                    target="_blank"
                    href="https://www.facebook.com/Sliceofdream"
                    className="
                  text-purple-500
                    inline-flex
                    items-center
                    md:mb-2
                    lg:mb-0
                  "
                  >
                    Order Now
                    <svg
                      className="w-4 h-4 ml-2"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="2"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M5 12h14"></path>
                      <path d="M12 5l7 7-7 7"></path>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="p-4 md:w-1/3">
            <div
              className="
              h-full
              border-2 border-gray-200 border-opacity-60
              rounded-lg
              overflow-hidden
            "
            >
              <motion.div className="menu-img" whileHover={{ opacity: 1 }}>
                <img
                  className="
                    lg:h-48
                    md:h-36
                    w-full
                    object-cover object-center
                    cursor-pointer
                  "
                  src={cake21}
                  alt="cake21"
                  onClick={() => setSelectedImg(cake21)}
                />
              </motion.div>
              <div className="p-6">
                <h1
                  className="
                  title-font
                  text-2xl
                  font-medium
                text-gray-600
                  mb-1
                "
                >
                  Lemon Bomb Cake
                </h1>
                <p className="leading-relaxed mb-1">Price: ৳700 per pound</p>
                <div className="flex items-center flex-wrap">
                  <a
                    rel="noreferrer"
                    target="_blank"
                    href="https://www.facebook.com/Sliceofdream"
                    className="
                  text-purple-500
                    inline-flex
                    items-center
                    md:mb-2
                    lg:mb-0
                  "
                  >
                    Order Now
                    <svg
                      className="w-4 h-4 ml-2"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="2"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M5 12h14"></path>
                      <path d="M12 5l7 7-7 7"></path>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="p-4 md:w-1/3">
            <div
              className="
              h-full
              border-2 border-gray-200 border-opacity-60
              rounded-lg
              overflow-hidden
            "
            >
              <motion.div className="menu-img" whileHover={{ opacity: 1 }}>
                <img
                  className="
                    lg:h-48
                    md:h-36
                    w-full
                    object-cover object-center
                    cursor-pointer
                  "
                  src={cake23}
                  alt="cake23"
                  onClick={() => setSelectedImg(cake23)}
                />
              </motion.div>
              <div className="p-6">
                <h1
                  className="
                title-font
                text-2xl
                font-medium
              text-gray-600
                mb-1
              "
                >
                  Red Velvet Cake with Cheese Cream Frosting
                </h1>
                <p className="leading-relaxed mb-1">Price: ৳850 per pound</p>
                <div className="flex items-center flex-wrap">
                  <a
                    rel="noreferrer"
                    target="_blank"
                    href="https://www.facebook.com/Sliceofdream"
                    className="
                  text-purple-500
                    inline-flex
                    items-center
                    md:mb-2
                    lg:mb-0
                  "
                  >
                    Order Now
                    <svg
                      className="w-4 h-4 ml-2"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="2"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M5 12h14"></path>
                      <path d="M12 5l7 7-7 7"></path>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="p-4 md:w-1/3">
            <div
              className="
              h-full
              border-2 border-gray-200 border-opacity-60
              rounded-lg
              overflow-hidden
            "
            >
              <motion.div className="menu-img" whileHover={{ opacity: 1 }}>
                <img
                  className="
                    lg:h-48
                    md:h-36
                    w-full
                    object-cover object-center
                    cursor-pointer
                  "
                  src={cake24}
                  alt="cake24"
                  onClick={() => setSelectedImg(cake24)}
                />
              </motion.div>
              <div className="p-6">
                <h1
                  className="
                  title-font
                  text-2xl
                  font-medium
                text-gray-600
                  mb-1
                "
                >
                  Jar of Happiness
                </h1>
                <p className="leading-relaxed mb-1">Price: ৳199 one jar</p>
                <div className="flex items-center flex-wrap">
                  <a
                    rel="noreferrer"
                    target="_blank"
                    href="https://www.facebook.com/Sliceofdream"
                    className="
                  text-purple-500
                    inline-flex
                    items-center
                    md:mb-2
                    lg:mb-0
                  "
                  >
                    Order Now
                    <svg
                      className="w-4 h-4 ml-2"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="2"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M5 12h14"></path>
                      <path d="M12 5l7 7-7 7"></path>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="p-4 md:w-1/3">
            <div
              className="
              h-full
              border-2 border-gray-200 border-opacity-60
              rounded-lg
              overflow-hidden
            "
            >
              <motion.div className="menu-img" whileHover={{ opacity: 1 }}>
                <img
                  className="
                    lg:h-48
                    md:h-36
                    w-full
                    object-cover object-center
                    cursor-pointer
                  "
                  src={cake2}
                  alt="cake2"
                  onClick={() => setSelectedImg(cake2)}
                />
              </motion.div>
              <div className="p-6">
                <h1
                  className="
                  title-font
                  text-2xl
                  font-medium
                text-gray-600
                  mb-1
                "
                >
                  ChocoNila Cup
                </h1>
                <p className="leading-relaxed mb-1">Price: ৳50 one cup</p>
                <div className="flex items-center flex-wrap">
                  <a
                    rel="noreferrer"
                    target="_blank"
                    href="https://www.facebook.com/Sliceofdream"
                    className="
                  text-purple-500
                    inline-flex
                    items-center
                    md:mb-2
                    lg:mb-0
                  "
                  >
                    Order Now
                    <svg
                      className="w-4 h-4 ml-2"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="2"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M5 12h14"></path>
                      <path d="M12 5l7 7-7 7"></path>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="p-4 md:w-1/3">
            <div
              className="
              h-full
              border-2 border-gray-200 border-opacity-60
              rounded-lg
              overflow-hidden
            "
            >
              <motion.div className="menu-img" whileHover={{ opacity: 1 }}>
                <img
                  className="
                    lg:h-48
                    md:h-36
                    w-full
                    object-cover object-center
                    cursor-pointer
                  "
                  src={cake25}
                  alt="cake25"
                  onClick={() => setSelectedImg(cake25)}
                />
              </motion.div>
              <div className="p-6">
                <h1
                  className="
                  title-font
                  text-2xl
                  font-medium
                text-gray-600
                  mb-1
                "
                >
                  Jar of LemonBomb
                </h1>
                <p className="leading-relaxed mb-1">Price: ৳175 one jar</p>
                <div className="flex items-center flex-wrap">
                  <a
                    rel="noreferrer"
                    target="_blank"
                    href="https://www.facebook.com/Sliceofdream"
                    className="
                  text-purple-500
                    inline-flex
                    items-center
                    md:mb-2
                    lg:mb-0
                  "
                  >
                    Order Now
                    <svg
                      className="w-4 h-4 ml-2"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="2"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M5 12h14"></path>
                      <path d="M12 5l7 7-7 7"></path>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <Link
            to="/menu"
            className="flex mx-auto mt-16 text-white bg-purple-500 border-0 py-2 px-8 focus:outline-none hover:bg-purple-600 rounded text-lg"
          >
            See More
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Menu;
